import React from "react";
import {Link, Typography} from "@one-thd/sui-atomic-components";
import {selectAutomationIdBasedOnComponent} from "../../../utils/automationIds";

const OtpTextLinkOptions = (props) => {
  const {
    textMeANewCode=()=>{},
    phoneMeANewCode=()=>{},
    navigateToModal=()=>{},
    resendNewCodeForOTPOptionsAndSetView=()=>{},
    isVerifyingExistingPhone=false,
    isVerifyingANewPhone=false,
    isPhoneVerified=false,
    isVerifyingUsersIdentity=false,
    verifyExistingPhone=false,
    origin,
    currentView
  } = props;

  const MODAL_VIEWS = {
    NEW_PHONE_VERIFICATION_EVOICE: "newPhoneVerificationEvoice",
    NEW_PHONE_VERIFICATION_SMS: "newPhoneVerificationSms",
    EMAIL_VIEW: "email",
    SMS_VIEW: "sms",
    PHONE_VIEW: "phone"
  }

  const VERBIAGE = {
    TEXT_ME_A_NEW_CODE: "Text me a new code",
    EMAIL_ME_A_NEW_CODE: "Email me a new code",
    PHONE_ME_A_NEW_CODE: "Call me with a new code",
  }

  const OTP_CHANNELS = {
    EMAIL: "email",
    SMS: "sms",
    PHONE: "phone"
  }

  const DEFAULT_PHRASES = {
    [OTP_CHANNELS.EMAIL]: VERBIAGE.EMAIL_ME_A_NEW_CODE,
    [OTP_CHANNELS.SMS]: VERBIAGE.TEXT_ME_A_NEW_CODE,
    [OTP_CHANNELS.PHONE]: VERBIAGE.PHONE_ME_A_NEW_CODE
  }

  const FLOWS = {
    VERIFY_EXISTING_PHONE: "VERIFY_EXISTING_PHONE" ,
    VERIFY_NEW_PHONE: "VERIFY_NEW_PHONE",
    VERIFYING_USERS_IDENTITY_WITH_VERIFIED_PHONE: "VERIFYING_USERS_IDENTITY_WITH_VERIFIED_PHONE"
  }


  let flow;
  if(isPhoneVerified && isVerifyingUsersIdentity) {
    flow = FLOWS.VERIFYING_USERS_IDENTITY_WITH_VERIFIED_PHONE
  } else if (isVerifyingExistingPhone) {
    flow = FLOWS.VERIFY_EXISTING_PHONE
  } else if (isVerifyingANewPhone) {
    flow = FLOWS.VERIFY_NEW_PHONE
  }

  const RESEND_VERBIAGE = {
    [OTP_CHANNELS.EMAIL]: "Resend the email message",
    [OTP_CHANNELS.SMS]: "Resend the text message",
    [OTP_CHANNELS.PHONE]: "Call me again with new code."
  }

  function verbiageSelectionForPhoneVerification (modalView, otpChannel) {
    if(modalView===MODAL_VIEWS.NEW_PHONE_VERIFICATION_EVOICE) {
      return otpChannel==="sms" ? VERBIAGE.TEXT_ME_A_NEW_CODE : RESEND_VERBIAGE["phone"]
    } else if(modalView===MODAL_VIEWS.NEW_PHONE_VERIFICATION_SMS) {
      return otpChannel==="sms" ? RESEND_VERBIAGE["sms"] : VERBIAGE.PHONE_ME_A_NEW_CODE
    }
  }

  const selectedFlow = (() => {
    if(origin==="emailEdit") return "email";
    if(origin==="phoneEdit") return "phone";
  })()

  function getAction (channel, currentView) {

    const actionsVerifiedPhoneIdentity = {
      email: "emailNewCode",
      sms: "newTextMessage",
      phone: "newPhoneMessage"
    }

    const resendActionsVerifiedPhoneIdentity = {
      email: "resendEmailIdentity",
      sms: "resendTextIdentity",
      phone: "resendPhoneIdentity"
    }

    let newActions = null;
    if(channel===currentView) {
      actionsVerifiedPhoneIdentity[channel] = resendActionsVerifiedPhoneIdentity[channel];
      newActions = actionsVerifiedPhoneIdentity
    }

    return newActions || actionsVerifiedPhoneIdentity;
  }

  function verbiageSelectionForVerifyingIdentity(view) {
    const phrases = {...DEFAULT_PHRASES};

    if(Object.keys(OTP_CHANNELS).includes(view.toUpperCase()) ) {
      phrases[view] = RESEND_VERBIAGE[view]
    }
    return Object.keys(phrases).map((channel, index) => {
      const selectedActions = getAction(channel, view);
      return (
        <Link data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, selectedActions[channel], true)}
              key={index} onClick={() => {
          resendNewCodeForOTPOptionsAndSetView(channel, channel, origin)
        }}>{phrases[channel]}</Link>
      )
    })
  }

  const textMeANewCodeForNewPhone = () => {
    textMeANewCode(); navigateToModal("newPhoneVerificationSms");
  }

  const phoneMeANewCodeForNewPhone = () => {
    phoneMeANewCode(); navigateToModal("newPhoneVerificationEvoice");
  }

  const textMeANewCodeForExistingPhone = () => {
    verifyExistingPhone("sms"); navigateToModal("newPhoneVerificationSms");
  };

  const phoneMeANewCodeForExistingPhone = () => {
    verifyExistingPhone("phone"); navigateToModal("newPhoneVerificationEvoice");
  };
  const [content, setContent] = React.useState();


  React.useEffect(()=>{
    if(flow===FLOWS.VERIFY_EXISTING_PHONE) {
      setContent(
        <div className="sui-flex sui-flex-col sui-gap-y-4">
          <Link data-automation-id={selectAutomationIdBasedOnComponent("phoneVerification",currentView==="newPhoneVerificationSms"?"resendTheTextMessage":"textMeANewCode")} onClick={textMeANewCodeForExistingPhone}>
            {verbiageSelectionForPhoneVerification(currentView, "sms")}
          </Link>
          <Link data-automation-id={selectAutomationIdBasedOnComponent("phoneVerification",currentView==="newPhoneVerificationEvoice"?"resendThePhoneMessage":"callMeWithANewCode")} onClick={phoneMeANewCodeForExistingPhone} >
            {verbiageSelectionForPhoneVerification(currentView, "phone")}
          </Link>
        </div>
      )
    } else if(flow===FLOWS.VERIFY_NEW_PHONE) {
      setContent(
        <div className="sui-flex sui-flex-col sui-gap-y-4">
          <Link data-automation-id={selectAutomationIdBasedOnComponent("phone", currentView==="newPhoneVerificationSms"?"resendText":"textNewCode", isPhoneVerified)} onClick={textMeANewCodeForNewPhone} >
            {verbiageSelectionForPhoneVerification(currentView, "sms")}
          </Link>
          <Link data-automation-id={selectAutomationIdBasedOnComponent("phone", currentView==="newPhoneVerificationEvoice"?"resendPhone":"callMeWithANewCode", isPhoneVerified)} onClick={phoneMeANewCodeForNewPhone} >
            {verbiageSelectionForPhoneVerification(currentView, "phone")}
          </Link>
        </div>
      )
    } else if (flow===FLOWS.VERIFYING_USERS_IDENTITY_WITH_VERIFIED_PHONE) {
      setContent(
        <div className="sui-flex sui-flex-col sui-gap-y-4">
          {verbiageSelectionForVerifyingIdentity(currentView)}
        </div>
      )
    }
  }, [isVerifyingExistingPhone, isVerifyingUsersIdentity, isVerifyingANewPhone])

  return (
    <React.Fragment>
        <div>
            <Typography>Didn&apos;t receive the code?</Typography>
            <div className="sui-my-4">
                {content}
            </div>
        </div>
    </React.Fragment>
  );
}

export default OtpTextLinkOptions;